import { AgGridReact, AgGridColumn } from "ag-grid-react";
import { Sidebar } from "primereact/sidebar";
import React from "react";
import { useState } from "react";
import useApiTarifaPermisionarios from "../../api/operaciones/useApiTarifasPermisionarios";
import Filtro from "../../shared/componentes/filtro";
import agGridHelper from "../../shared/ag-grid-helper";
import { getSessionState } from "../../hooks/useSessionState";
import ButtonIcon from "../../shared/controls/ButtonIcon";
import constantes from "../../catalogos/constantes";
import useSeguridad from "../../Seguridad/useSeguridad";
import FiltroTarifaPermisionarios from "./filtroTarifaPermisionarios";
import TarifaPermisionarioDetalle from "./TarifaPermisionarioDetalle";
const TarifaPermisionarios = () =>{
    const seguridad = useSeguridad();
    const [datos,setDatos] = useState([]);
    const [gridApi, setGridApi] = useState(null)
    const api = useApiTarifaPermisionarios();
    const filtroKey = "FiltroTarifaPermisionario"
    const [sidebarVisible, setSidebarVisible]=useState(false);
    const [tarifaPermisionarioId, setTarifaPermisionarioId] = useState(0);

   async function buscar(filtro, paramsApi) {
    agGridHelper.showLoad(gridApi, paramsApi, true);

    const savedFilter = getSessionState(filtroKey) ?? {};
    const filtroApi = {
        ...savedFilter,          
        ...filtro,               
        estadoOrigenId: filtro?.estadoOrigenId?.id ?? 0,
        municipioOrigenId: filtro?.municipioOrigenId?.id ?? 0,
        estadoDestinoId: filtro?.estadoDestinoId?.id ?? 0 ,
        municipioDestinoId: filtro?.estadoDestinoId?.id ?? 0 ,
        tipoUnidadId: filtro?.tipoUnidadId ?? 3
    };

    const datosApi = await api.filtrar(filtroApi);

    setDatos(datosApi);
    agGridHelper.hideLoad(gridApi, paramsApi, false);
    }

    const soloLectura = !seguridad.esEditable(constantes.menus.tarifaPermisionario);

     async function nuevo() {
        setSidebarVisible(true);
        setTarifaPermisionarioId(0);
    };
    async function onSave() {
        setSidebarVisible(false);
        await buscar();
    }
    const onGridReady = async (params) => {
        setGridApi(params.api);
    };
    const ediTarifa = (id) =>{
        setSidebarVisible(true)
        setTarifaPermisionarioId(id)
    }

    const ButtonsHeader = () => {
         return (
            <div className="ag-grid header-icons">
                {!soloLectura &&
                    <ButtonIcon title="Agregar" className={'grid-action'} iconName={'MdAddBox'} onClick={nuevo}/>
                }
            </div>
        );
    };
    const rowButtons = ({ data, rowIndex, api, context }) => (
        <div className="ag-grid row-icons">
              <ButtonIcon title={'Editar'} iconName={'FaRegEdit'} onClick={() => context.ediTarifa(data.id)} />

        </div>
    );


    return(
        <>
              <Sidebar visible={sidebarVisible} position="right" dismissable={false} className="p-sidebar-md" onHide={() => setSidebarVisible(false)}>
                 <TarifaPermisionarioDetalle tarifaPermisionarioId={tarifaPermisionarioId} onSave={onSave} soloLectura={soloLectura} />
            </Sidebar>
           <Filtro filtroKey={filtroKey} handleSubmit={buscar} defaultValue={{ nombre: '' }} gridApi={gridApi}
                classButtons="field-iconos btn-group">
                <FiltroTarifaPermisionarios />
            </Filtro>
            <div className="ag-theme-balham grid-principal com-conceptosCobro">
                <AgGridReact enableSorting={true}
                    enableFilter={true}
                    pagination={true}
                    className=""
                        frameworkComponents={{
                        rowButtons: rowButtons,
                        gotoDetail: agGridHelper.GoToDetailFormatter,
                        buttonsHeader: ButtonsHeader,
                        dateFormatter: agGridHelper.DateFormatter,
                        imageFormatter: agGridHelper.ImageFormatter
                    }}
                    onGridReady={onGridReady}
                    rowData={datos}
                    overlayLoadingTemplate={agGridHelper.loadingOverlay}
                    defaultColDef={agGridHelper.defaultColumns}
                    rowHeight={35}
                     context={{
                        ediTarifa: ediTarifa
                    }}>
                    
                    <AgGridColumn field="permisionario" headerName="Permisionario" text cellStyle={{ textAlign: "left" }} />  
                    <AgGridColumn field="tipoUnidad" headerName="Tipo de unidad" text cellStyle={{ textAlign: "left" }} />   
                    <AgGridColumn field="tipoViaje" headerName="Tipo viaje" text cellStyle={{ textAlign: "left" }} /> 
                    <AgGridColumn field="estadoOrigen" headerName="Estado Origen" text cellStyle={{ textAlign: "left" }} /> 
                    <AgGridColumn field="municipioOrigen" headerName="Municipio Origen" text cellStyle={{ textAlign: "left" }} /> 
                    <AgGridColumn field="estadoDestino" headerName="Estado Destino" text cellStyle={{ textAlign: "left" }} /> 
                    <AgGridColumn field="municipioDestino" headerName="Municipio Destino" text cellStyle={{ textAlign: "left" }} />   
                    <AgGridColumn field="tarifa" headerName="Tarifa" text cellStyle={{ textAlign: "left" }} />                     
                    <AgGridColumn maxWidth={80}
                        headerName="VER"
                        cellRenderer="rowButtons"
                        pinned={'right'}
                        cellClass={'left'}
                        headerComponent="buttonsHeader" />
                </AgGridReact>
            </div>
        </>
    )

}
export default TarifaPermisionarios;